// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._DSBdu{height:6px !important;line-height:0 !important}@media (max-width: 599px){._DSBdu{height:5px !important}}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `_DSBdu`
};
export default ___CSS_LOADER_EXPORT___;
